module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Medium.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Medium.eot
 ** module id = 346
 ** module chunks = 0
 **/